import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { useBreakpoints } from 'hooks'

import { Button } from 'components'
import ProfileSectionTitle from 'components/Profile/ProfileSectionTitle'

const ProfileSectionStickyTitle = ({ hasChanges, children, ...rest }) => {
  const { md } = useBreakpoints()

  return (
    <ProfileSectionTitle
      className={classnames(
        'sticky right-0 w-full bg-black z-15 pb-3 md:z-0 md:top-0 md:bg-transparent md:relative md:pb:0'
      )}
      style={!md && hasChanges ? { top: '72px' } : {}}
      {...rest}
    >
      <div className="w-full flex items-center justify-between">
        <div>{children}</div>
        {!md && hasChanges && (
          <Button
            className="bg-secondaryGradient text-sm  h-9 font-tomatoGrotesk rounded-full"
            textColor="text-black"
            loaderColor="text-black"
            {...rest}
          >
            Save
          </Button>
        )}
      </div>
    </ProfileSectionTitle>
  )
}

ProfileSectionStickyTitle.propTypes = {
  hideBorder: PropTypes.bool,
}

export default ProfileSectionStickyTitle
